import { buildModelManager } from "../builder.js";
const DefaultMembershipSelection = {
  __typename: true,
  id: true,
  acceptedAt: true,
  createdAt: true,
  deletedAt: true,
  icsFeedEnabled: true,
  icsFeedIncludeTentative: true,
  icsFeedToken: true,
  invitedAt: true,
  isActive: true,
  performsWork: true,
  profileId: true,
  revokedAt: true,
  role: true,
  schedulingModeOverride: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "membership";
const pluralModelApiIdentifier = "memberships";
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByIcsFeedToken",
    findByField: "icsFeedToken",
    findByVariableName: "icsFeedToken",
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByIcsFeedToken",
    findByField: "icsFeedToken",
    findByVariableName: "icsFeedToken",
    modelApiIdentifier,
    defaultSelection: DefaultMembershipSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createMembership",
    operationReturnType: "CreateMembership",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { membership: { required: false, type: "CreateMembershipInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkCreateMemberships",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "updateMembership",
    operationReturnType: "UpdateMembership",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      membership: { required: false, type: "UpdateMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateMemberships",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "configureIcsFeedMembership",
    operationReturnType: "ConfigureIcsFeedMembership",
    functionName: "configureIcsFeed",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      membership: { required: false, type: "ConfigureIcsFeedMembershipInput" },
      operation: { required: false, type: "String" },
      includeTentative: { required: false, type: "Boolean" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["operation", "includeTentative"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkConfigureIcsFeedMemberships",
    functionName: "bulkConfigureIcsFeed",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "configureIcsFeed",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkConfigureIcsFeedMembershipsInput!]"
      }
    },
    paramOnlyVariables: ["operation", "includeTentative"],
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "restoreMembership",
    operationReturnType: "RestoreMembership",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      membership: { required: false, type: "RestoreMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreMemberships",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "revokeMembership",
    operationReturnType: "RevokeMembership",
    functionName: "revoke",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      membership: { required: false, type: "RevokeMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkRevokeMemberships",
    functionName: "bulkRevoke",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "revoke",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRevokeMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "upsertMembership",
    operationReturnType: "UpsertMembership",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      membership: { required: false, type: "UpsertMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateMembershipResult": { hasReturnType: false },
      "... on UpdateMembershipResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertMemberships",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertMembershipsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultMembershipSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "membershipGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const MembershipManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultMembershipSelection,
  operations
);
export {
  DefaultMembershipSelection,
  MembershipManager
};
//# sourceMappingURL=Membership.js.map
